import React from 'react';
import { Link } from 'react-router-dom';
import ProjektanfrageButton from '../ProjectRequest/Projektanfrage';
import '../../styles/service-hero.css';
import './UIUXHeroSection.css';

/**
 * UI/UX hero: header plus a decorative "design canvas" built entirely in
 * CSS — an artboard with color swatches, a type specimen and a component
 * sample, accompanied by floating collaborator cursors. No image payload.
 */
const UIUXHeroSection = () => {
  return (
    <section className="uiux-hero">
      <div className="service-hero-copy">
        <h1 className="service-hero-title">
          Digitale Produkte, die Nutzer intuitiv verstehen
        </h1>
        <p className="service-hero-lead">
          Von der Nutzerforschung über Wireframes bis zum fertigen Interface:
          Wir gestalten Benutzeroberflächen, die Ästhetik und Funktionalität
          vereinen – und Ihre Conversion messbar verbessern.
        </p>
        <div className="service-hero-actions">
          <ProjektanfrageButton />
          <Link to="/services/web-development" className="service-hero-secondary">
            Mehr zur Umsetzung
          </Link>
        </div>
      </div>

      <div className="uiux-canvas" aria-hidden="true">
        <div className="uiux-artboard">
          <div className="uiux-artboard-bar">
            <span />
            <span />
            <span />
            <em>styleguide.fig</em>
          </div>

          <div className="uiux-artboard-body">
            <div className="uiux-panel uiux-panel-colors">
              <p className="uiux-panel-label">Farben</p>
              <div className="uiux-swatches">
                <span className="uiux-swatch" style={{ backgroundColor: '#166534' }} />
                <span className="uiux-swatch" style={{ backgroundColor: '#2ba84a' }} />
                <span className="uiux-swatch" style={{ backgroundColor: '#a7dcb8' }} />
                <span className="uiux-swatch" style={{ backgroundColor: '#1e293b' }} />
                <span className="uiux-swatch" style={{ backgroundColor: '#f3f6f9' }} />
              </div>
            </div>

            <div className="uiux-panel uiux-panel-type">
              <p className="uiux-panel-label">Typografie</p>
              <div className="uiux-type-row">
                <span className="uiux-type-specimen">Aa</span>
                <div className="uiux-type-bars">
                  <span style={{ width: '82%' }} />
                  <span style={{ width: '64%' }} />
                  <span style={{ width: '44%' }} />
                </div>
              </div>
            </div>

            <div className="uiux-panel uiux-panel-component">
              <p className="uiux-panel-label">Komponente</p>
              <div className="uiux-component-card">
                <span className="uiux-component-avatar" />
                <div className="uiux-component-lines">
                  <span style={{ width: '72%' }} />
                  <span style={{ width: '48%' }} />
                </div>
                <span className="uiux-component-button">Anfragen</span>
              </div>
            </div>
          </div>
        </div>

        <div className="uiux-cursor uiux-cursor-research">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M5.5 3.2 19 10.4l-6 1.5-2.6 5.6L5.5 3.2z" />
          </svg>
          <span>UX Research</span>
        </div>
        <div className="uiux-cursor uiux-cursor-design">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M5.5 3.2 19 10.4l-6 1.5-2.6 5.6L5.5 3.2z" />
          </svg>
          <span>UI Design</span>
        </div>
      </div>
    </section>
  );
};

export default UIUXHeroSection;
